import { IColorStyles } from "../models";

export const getColorStyles = (colorValue: string): IColorStyles => {
  const style = { background: '' };
  const colors: string[] = colorValue.split('|');

  if (colors.length === 0) {
    return style;
  }

  let percents = 0;
  const delta: number = Math.floor(100 / colors.length);

  style.background =
    colors.reduce((accumulator: string, color: string): string => {
      return `${accumulator}, #${color} ${percents}%, #${color} ${(percents += delta)}%`;
    }, 'linear-gradient(45deg') + ')';

  return style;
};
